import { getContract } from "../web3/contractBuilder";

const BASE_URL = process.env.REACT_APP_WALLET_API_URL;
const network = process.env.REACT_APP_PNFT_NETWORK;
// polygon+mumbai is not being used atm
const contract = process.env.REACT_APP_PNFT_TOKEN_CONTRACT_ADDRESS;


// 'polygon%2Bmainnet/0xf8173a39c56a554837C4C7f104153A005D284D11/token/0x7646c2e54f972ea0def55b66b4f05416acd49db0?limit=2000'
export async function fetchPublisherNFTs(wallet, signal) {
    // wallet = '0xF6E27BaA0E5c084FA637106E4Bbb285e66Ea59EC'
    const url = `${BASE_URL}/${network}/${contract}/token/${wallet}`

    const res = await fetch(url)
    return res.json();
}

export async function fetchGenesis(web3, wallet) {
    const contract = getContract("GenesisNFT", web3)

    return contract.methods.balanceOfBatch([wallet, wallet], [1, 2]).call()
}